import { render, staticRenderFns } from "./edit-report-modal.vue?vue&type=template&id=8b04e0d8"
import script from "./edit-report-modal.vue?vue&type=script&lang=js"
export * from "./edit-report-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-report-modal.vue?vue&type=style&index=0&id=8b04e0d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports